import { memo } from 'react';
import { Handle, Position } from 'react-flow-renderer';
import { RiGroupLine } from 'react-icons/ri';

const GroupNode = ({ data }) => (
    <div className="node group">
        <RiGroupLine size={30} color="#ffffff" className="mb-2" />
        <div>{data.label}</div>

        <Handle type="target" position={Position.Top} />
        <Handle type="source" position={Position.Bottom} />
    </div>
);

export default memo(GroupNode);
